/**
 * Copyright (c) 2025-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// N.B! AUTOGENERATED FILE. DO NOT EDIT
// Source: RemixIcon
// License: Apache License 2.0
import type { JSX } from "react";
import { Icon, type Props } from "../Icon";
export const MegaphoneFill = (props: Props): JSX.Element => (
  <Icon fill="currentColor" viewBox="0 0 24 24" {...props}>
    <path d="M21 10.06V4a1 1 0 0 0-1-1h-1c-1.98 1.98-5.7 3.09-8 3.61V17.4c2.3.52 6.02 1.63 8 3.61h1a1 1 0 0 0 1-1v-6.06a2 2 0 0 0 0-3.88M5 7a2 2 0 0 0-2 2v6c0 1.1.9 2 2 2h1l1 5h2V7z" />
  </Icon>
);
